import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtilService } from '../../../../services/util.service';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-list-files',
  templateUrl: './list-files.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ListFilesComponent implements OnInit {
  files: string[];
  constructor(
    private utilService: UtilService,
    private authorizeService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    var user = this.authorizeService.getUser();
    if (user == null) {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/lstf' }
      });
    } else {
      this.utilService.getFiles('imagens/vl').subscribe((f) => {
        this.files = f;
      });
    }
  }
}
